import { z } from 'zod'
import { createdAtSortQueryShape, creatorListQueryShape } from '../list-query/contract.ts'

export const wecomDeliveryListSchema = z.object({
  botId: z.uuid(),
  current: z.number().int().positive().default(1),
  pageSize: z.number().int().positive().max(100).default(20),
  id: z.number().int().positive().optional(),
  keyword: z.string().trim().max(100).optional(),
  purpose: z.enum(['customer-collection', 'integration-test']).optional(),
  status: z.enum(['pending', 'sending', 'accepted', 'failed', 'unknown']).optional(),
  ...creatorListQueryShape,
  ...createdAtSortQueryShape
})
export type WecomDeliveryListInput = z.input<typeof wecomDeliveryListSchema>

export const wecomTestSendSchema = z.strictObject({
  botId: z.uuid(),
  requestId: z.uuid(),
  chatId: z
    .string()
    .trim()
    .min(1, '请输入企微群 ID')
    .max(255)
    .regex(/^[A-Za-z0-9_-]+$/, '请输入有效的群聊 chatid'),
  messageType: z.enum(['markdown', 'pdf'])
})
export const wecomLeaseSchema = z.strictObject({
  id: z.number().int().positive(),
  leaseToken: z.uuid()
})
export const wecomAcknowledgeSchema = wecomLeaseSchema.extend({
  status: z.enum(['accepted', 'unknown', 'failed']),
  platformRequestId: z.string().max(255).optional()
})
export const wecomHeartbeatSchema = z.strictObject({
  instanceId: z.uuid(),
  botVersion: z.number().int().positive()
})

// 当前仅开放无业务数据的联调内容；业务账单应由领域 Service 生成并授权。
export const wecomPushPayloadSchema = z.discriminatedUnion('messageType', [
  z.object({ messageType: z.literal('markdown'), content: z.string().min(1).max(2000) }),
  z.object({
    messageType: z.literal('pdf'),
    fileName: z
      .string()
      .max(255)
      .regex(/^[^/\\]+\.pdf$/i)
      .refine((name) => [...name].every((character) => character.charCodeAt(0) >= 32), '文件名不能包含控制字符'),
    base64: z.string().min(1).max(28_000_000)
  })
])
export type WecomPushPayload = z.infer<typeof wecomPushPayloadSchema>
export type WecomTestSendInput = z.infer<typeof wecomTestSendSchema>
export type WecomGatewayIdentity = {
  botId: string
  credentialId: string
  credentialVersion: number
}
